import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TableRow } from '@cargomatic/ui';
export function SortableRow({ children, id, }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging, } = useSortable({ id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };
    const listenersRef = React.useRef(listeners);
    listenersRef.current = listeners;
    return (React.createElement(TableRow, Object.assign({ ref: setNodeRef, style: style }, attributes, { "data-row-id": id }), children));
}
export function DraggableRowWrapper({ id, children, onListenersReady, }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging, } = useSortable({ id });
    React.useEffect(() => {
        onListenersReady(listeners);
    }, [listeners, onListenersReady]);
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };
    return (React.createElement(TableRow, Object.assign({ ref: setNodeRef, style: style }, attributes), children));
}
